import { CortexSetting, LocationVarKey } from "@swivl-mono/types";

import { CortexSettingRow } from "../../Components/CortexSettingRow";
import { TopicCard } from "../../Components/TopicCard";

export const TOPIC_VARS: LocationVarKey[] = [LocationVarKey.CortexCreateLeadForMovingTrucks];

const CREATE_LEAD_FOR_MOVING_TRUCKS_SETTING: CortexSetting = {
  kind: "toggle",
  key: "createLeadForMovingTrucks",
  varKey: LocationVarKey.CortexCreateLeadForMovingTrucks,
  label: "Create leads for moving-truck-only inquiries",
  description:
    "When ON, a visitor whose only interest is renting a moving truck (U-Haul etc.) still creates a CRM/FMS lead on hand-off. Turn OFF if truck rentals are referred out (e.g. a U-Haul deal) — the team ticket is still created, only the lead is skipped.",
  default: true
};

export function LeadCreationTopic(): React.ReactElement {
  return (
    <TopicCard title="Lead Creation" description={"When the bot's sales-tagged hand-offs auto-create a CRM/FMS lead."}>
      <CortexSettingRow setting={CREATE_LEAD_FOR_MOVING_TRUCKS_SETTING} layout="horizontal" />
    </TopicCard>
  );
}
